import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const InsightsContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const Count = styled.div<{ $isDisabled?: boolean }>`
  ${typographyV2.bodyXs};
  color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--text-disabled)' : 'var(--text-soft)'};
  width: 15px;
  height: 16px;
`;
